"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _bugsnag = _interopRequireDefault(require("./transports/bugsnag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var loggerFactories = {
  bugsnag: _bugsnag["default"]
};
var logLevels = ['error', 'warn', 'info', 'verbose', 'debug', 'silly'];

/**
 * @param {Function} loggerFactory - A logger factory is called with a level.
 * @returns {object} - A logger with all the log levels as methods.
 */
var buildLoggerForFunction = function buildLoggerForFunction(loggerFactory) {
  return (0, _lodash["default"])(logLevels).map(function (level) {
    return [level, loggerFactory(level)];
  }).fromPairs().value();
};

/**
 * A naive implementation where we grab the first getErrorBoundary.
 *
 * @param {object[]} loggers - A list of configured loggers.
 * @returns {Function} - A function that returns a React error boundary.
 */
var buildGetErrorBoundary = function buildGetErrorBoundary(loggers) {
  var firstLoggerWithAnErrorBoundary = _lodash["default"].find(loggers, function (logger) {
    return _lodash["default"].has(logger, 'getErrorBoundary');
  });
  if (!firstLoggerWithAnErrorBoundary) {
    return function () {
      return function (_ref) {
        var children = _ref.children;
        return children;
      };
    };
  }
  return firstLoggerWithAnErrorBoundary.getErrorBoundary;
};

// Example config object:
// {
//   bugsnagLog: {
//     transport: 'bugsnag',
//     level: 'error',
//     key: 'fffff-wefwef-wefwecwctgev',
//   },
// }

/**
 * @param {object} config - Logging config for the application.
 * @param {object} options - Options that are globally used across multiple loggers.
 * @param {string} options.application - Name of the application.
 * @param {object} options.React - This application’s instance of React.
 * @param {string} options.releaseStage - Name of the release stage (production, staging, etc).
 * @param {Function} options.getCustomData - Callback that should return an object with custom data.
 * @param {string} options.version - A unique identifier for this version, either semver or a SHA.
 * @returns {object} - A logger with all the log levels as methods, as well as getErrorBoundary.
 */
var globalLoggerFactory = function globalLoggerFactory(config, options) {
  var loggers = _lodash["default"].compact(_lodash["default"].map(config, function (loggerConfig, name) {
    var loggerFactory = loggerFactories[loggerConfig.transport];
    if (!loggerFactory) {
      return null;
    }

    // In a node environment some transports will return null
    var transportLogger = loggerFactory(loggerConfig, options);
    if (!transportLogger) {
      return null;
    }
    return _objectSpread({
      name: name
    }, transportLogger);
  }));
  var logToEveryTransport = function logToEveryTransport(level) {
    var loggersForThisLevel = _lodash["default"].filter(loggers, function (logger) {
      return _lodash["default"].findIndex(logLevels, level) <= _lodash["default"].findIndex(logLevels, logger.level);
    });
    return function (message) {
      var metaData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _lodash["default"].forEach(loggersForThisLevel, function (logger) {
        var getCustomData = _lodash["default"].get(options, 'getCustomData', _lodash["default"].noop);
        var customData = getCustomData();
        return logger.log({
          customData: customData,
          level: level,
          message: message,
          metaData: metaData
        });
      });
    };
  };
  return _objectSpread(_objectSpread({}, buildLoggerForFunction(logToEveryTransport)), {}, {
    getErrorBoundary: buildGetErrorBoundary(loggers)
  });
};
var _default = globalLoggerFactory;
exports["default"] = _default;